<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle1"><a id="page_1"></a><strong>THIS IS ONLY A TEST</strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// half01.vue?b047a222